<template>
<div
    v-if="plan != null"
>
<h2
    style="margin-bottom: 15px;"
>
    {{label}}
</h2>

<div
    style="text-align: center; "
    v-if="plan.stages.length == 0"
>
    Your plan is empty.  <a v-on:click="addStage">Click here to add a step.</a>
</div>

<v-card
    v-for="(stage, index) in plan.stages"
    :key="index"
    style="margin-bottom: 15px"
        
>
    <v-card-title>Stage {{index+1}}</v-card-title>

    <v-card-text>

    <m-edit-chip
        label="Who can be notified"
        :dialog_title="'Who can be notified in stage ' + (index+1)"
        :value="createStageChips(stage)"
        :possible_values="createPossibleChips()"
        :read_only="read_only"
        v-on:input="setStageValue($event,index)"
    />

    <m-edit-select
        label="How to pick who to notify"
        :value="getNotificationType(stage.step.action.type)"
        :possible_values="notification_options"
        :read_only="read_only"
        v-on:input="setNotificationType($event,index)"
    />

    <m-edit-text
        label="How long to wait after sending a notification (in minutes)"
        :value="''+describeWaitTime(stage.step.wait_time)"
        v-on:input="setWaitTime($event,index)"
        :read_only="read_only"
        integer_positive_non_zero
    />

    <m-edit-text
        label="How many times to repeat this process before advancing to the next stage"
        :value="''+stage.repeat_count"
        :read_only="read_only"
        integer_positive_non_zero
        v-on:input="setRepeatCount($event,index)"
    />

    

    </v-card-text>

    <div
        style="position: absolute; right: 20px; top: 20px;"
    >
        <v-menu 
            bottom 
            offset-y  
        >

                <template v-slot:activator="{ on }">
                    
                    <v-icon
                        v-on="on"
                        color="primary"
                    >
                        mdi-dots-vertical
                    </v-icon>
                    
                </template>

                <v-list>
                    <v-list-item
                        :disabled="index == 0"
                        v-on:click="moveStage(index,true)"
                    >
                        <v-list-item-title>Move Up</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :disabled="index == plan.stages.length-1"
                        v-on:click="moveStage(index,false)"
                    >
                        <v-list-item-title>Move Down</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-on:click="newStage(index, true)"
                    >
                        <v-list-item-title>New stage before</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="newStage(index, false)"
                    >
                        <v-list-item-title>New stage after</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-on:click="deleteStage(index)"
                    >
                        <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>

                </v-list>

            </v-menu>


    </div>

</v-card>
</div>
</template>

<script>
const _ = require('lodash');
const { v4: uuidv4 } = require('uuid');

export default {
    props: {
        value: {
            type: Object,
            default: function() { return null; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },

        organization_id: { 
            type: String,
            default: function () { return null; }
        },

        label: {
            type: String,
            default: function() { return 'Notification Plan'; },
        },
    },

    data() {
        return {
            plan: null,
            selector_options: [],

            notification_options: [
                { 'text' : 'Simultaneously notify all users that are available', code: 'simultaneous' },
                { 'text' : 'Pick, at random, one RedChirp user who is available and notify them', code: 'random' },
                { 'text' : 'Using round robin, pick one RedChirp user who is available and notify them', code: 'round-robin' },
            ],
        }
    },

    mounted () {
        this.plan = this.addNewNotificationFields(_.cloneDeep(this.value));
        this.loadChips();
    },

    methods: {

        loadChips()
        {
            if ( this.organization_id == null ) return;

            this.$rc.getEmployeeSelectorOptions(
                this.organization_id,
            
                (data) => {
                    this.selector_options = data.all_selector_options;
                },
            
                () => {
                    
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        createStageChips(stage)
        {
            // selected_object_ids

            let selected_object_ids = stage.step.action.employee_selector.selected_object_ids;

            let ret = [];

            for ( let i = 0; i < selected_object_ids.length; i++ )
            {
                let label = this.getObjectDesc(selected_object_ids[i]);
                if ( label == null ) continue;

                ret.push({
                    'text' : label,
                    'selected_object_id' : selected_object_ids[i]
                })
            }

            return ret;
        },

        createPossibleChips()
        {
            let options = this.selector_options;

            let ret = [];

            for ( let i = 0; i < options.length; i++ )
            {
                if ( options[i].is_archived )
                    continue;

                ret.push({
                    'text' : options[i].label,
                    'selected_object_id' : options[i].selected_object_id,
                });
            }

            return ret;
        },

        getObjectDesc(id)
        {
            let options = this.selector_options;

            for ( let i = 0; i < options.length; i++ )
            {
                if ( options[i].selected_object_id == id )
                    return options[i].label;
            }

            return null;
        },

        getNotificationType(type)
        {
            let options = this.notification_options;

            for ( let i = 0; i < options.length; i++ )
            {
                if ( options[i].code == type )
                    return options[i];
            }

            return { 'text' : type, 'code' : type }; 
        },

        describeWaitTime(wait_time)
        {
            let in_minutes = wait_time / 1000 / 60;

            return Math.round(in_minutes);
        },

        newStage(index, is_before)
        {
            let new_index = index;

            if ( !is_before )
                new_index++;

            this.plan.stages.splice(new_index, 0, this.createDefaultStage());

            this.onChange();
        },

        createDefaultStage()
        {
            return {
            "step": 
            {
                "action": {
                "type": "simultaneous",
                "employee_selector": {
                    "organization_id": this.organization_id,
                    "selected_object_ids": []
                },
                "action_id": ''+uuidv4()
                },
                "wait_time": 300000,
            },
            "repeat_count": 2
            };
        },

        onChange()
        {
            this.$emit('input', _.cloneDeep(this.plan));
        },

        addStage()
        {
            this.plan.stages.push(this.createDefaultStage());
            this.onChange();
        },

        moveStage(index, move_up)
        {
            let other_index = index-1;

            if( !move_up )
                other_index = index+1;

            if ( other_index < 0 ) return;
            if ( other_index >= this.plan.stages.length ) return;

            let at_index = this.plan.stages[index];
            let at_other_index = this.plan.stages[other_index];

            this.plan.stages[index] = at_other_index;
            this.plan.stages[other_index] = at_index;

            this.onChange();
        },

        deleteStage(index)
        {
            this.plan.stages.splice(index, 1);
            this.onChange();
        },

        setStageValue(event, index)
        {
           let obj_ids = [];

           for ( let i = 0; i < event.length; i++ )
           {
               let cur_event = event[i];

               obj_ids.push(cur_event.selected_object_id);
           }

           this.plan.stages[index].step.action.employee_selector.selected_object_ids = obj_ids;

           this.onChange();
        },

        setNotificationType(value,stage_index)
        {
            this.plan.stages[stage_index].step.action.type = value.code;
            this.onChange();
        },

        setWaitTime(value, index)
        {
            let as_int = parseInt(value);
            
            if ( isNaN(as_int) || as_int < 1 ) 
            {
                alert("Value must be an number of minutes greater than or equal to one");
                return;
            }

            this.plan.stages[index].step.wait_time = as_int*1000*60;

            this.onChange();
        },

        setRepeatCount(value,index)
        {
            let as_int = parseInt(value);
        
            this.plan.stages[index].repeat_count = as_int;

            this.onChange();
        },
    },

    watch: {
        value(newValue, oldValue) {
            this.plan = _.cloneDeep(newValue);
        },

        organization_id(newValue,oldValue)
        {
            this.loadChips();
        }
    },
}
</script>

<style lang="scss" scoped>

</style>